import type { SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorComponent, type ErrorComponentProps, FailureImage } from '../Error';

interface GeneralErrorProps extends Partial<ErrorComponentProps> {
  onClick: (ev: SyntheticEvent<HTMLButtonElement>) => void;
  'data-test'?: string;
}

export function GeneralError(props: GeneralErrorProps): JSX.Element {
  const { actions, subtitle, titlePrefix, title } = props;
  const { t } = useTranslation();

  return (
    <ErrorComponent
      titlePrefix={titlePrefix}
      title={title || t('Ooops!')}
      subtitle={subtitle || t('Something went wrong. Please refresh your browser.')}
      PictureComponent={FailureImage}
      data-test={props['data-test'] || 'general-error'}
      actions={
        actions || [
          {
            children: t('Refresh'),
            color: 'secondary',
            'data-test': 'button-refresh',
            onClick: props.onClick,
            variant: 'contained',
          },
        ]
      }
    />
  );
}
